import { ChartSpline } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ChartIcon = createLucideIcon(ChartSpline);
